import { SVGProps } from 'react';

const PlayProfile = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg {...props} width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='32' cy='32' r='32' fill='#FFDB01' />
      <path
        d='M42.2836 30.8399L24.8762 22.1358C24.6783 22.0375 24.4586 21.9912 24.2378 22.0014C24.017 22.0116 23.8025 22.0779 23.6145 22.1942C23.4266 22.3104 23.2713 22.4726 23.1635 22.6656C23.0558 22.8585 22.999 23.0758 22.9985 23.2968V40.7042C22.9989 40.9252 23.0556 41.1425 23.1634 41.3354C23.2712 41.5284 23.4265 41.6906 23.6145 41.8068C23.8025 41.923 24.0171 41.9892 24.2379 41.9993C24.4587 42.0093 24.6784 41.9629 24.8762 41.8643L42.2836 33.161C42.4991 33.0532 42.6803 32.8875 42.8069 32.6826C42.9336 32.4776 43.0007 32.2414 43.0007 32.0005C43.0007 31.7595 42.9336 31.5233 42.8069 31.3184C42.6803 31.1134 42.4991 30.9477 42.2836 30.8399Z'
        fill='#070708'
      />
    </svg>
  );
};

export default PlayProfile;
